export enum   NotificationCategoryTypeEnum {
  Tickets = 'Tickets',
  Releases = 'Releases',
  Sprint = 'Sprint',
  Team = 'Team',
  Project = 'Project',
  TimeReporting = 'Time Reporting',
  WorkFlow = 'WorkFlow',
  Billing = 'Billing',
}

export enum NotificationMethodEnum {
  Web = 'isWebEnabled',
  Email = 'isEmailEnabled',
}
export const NOTIFICATION_SECTIONS = [
  "Tickets",
  "Releases",
  "Sprint",
  "Team",
  "Project",
  "Time Reporting",
  "WorkFlow",
  "Billing",
];
export interface NotificationSetting{
  _id: string;
  type: string;
  isWebEnabled: boolean;
  isEmailEnabled: boolean;
  category: NotificationCategoryTypeEnum;
  createdAt: string;
  updatedAt: string;
}


export interface NotificationRowProps {
  row: NotificationSetting;
  gridTemplateColumns: string;
  onToggle: (id: string, field: NotificationMethodEnum) => void;
}

export interface NotificationHeader {
  id: string;
  name: string;
  sortable: boolean;
}

export interface NotificationSettingsState {
  isLoading: boolean;
  settings: NotificationSetting[];
}
